var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tel)?_c('a',{staticClass:"link-with-icon",attrs:{"href":("tel:" + _vm.tel)}},[_c('v-icon',{attrs:{"color":"primary","small":""}},[_vm._v("mdi-phone")]),_c('span',[_vm._v(_vm._s(_vm.text))])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }